import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../../../api/api";
import "../../../../components/table.css";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import BackButton from "../../../../components/BackButton";

const handleDownload = async (docId, fileName) => {
  try {
    const response = await api.get(`/download-document/user/${docId}`, { responseType: 'blob' });
    const blob = response.data;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName || 'document';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Download failed:', error);
  }
};

const UserDocuments = () => {
  const { id } = useParams();
  const [documents, setDocuments] = useState([]);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  useEffect(() => {
    const fetchData = async () => {
      console.log("Fetching documents for userId:", id);
      try {
        // Fetch documents for the user
        const docsResponse = await api.get(`/user-documents/${id}`);
        console.log("API response:", docsResponse.data);
        setDocuments(
          Array.isArray(docsResponse.data.documents)
            ? docsResponse.data.documents
            : []
        );
        console.log("Documents set:", docsResponse.data.documents);
      } catch (error) {
        console.error("Failed to fetch data:", error);
        setDocuments([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  //  // Pagination calculations
  const totalPages = Math.ceil(documents.length / itemsPerPage) || 1;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = documents.slice(startIndex, startIndex + itemsPerPage);

  const goToPage = (page) => {
    if (page < 1) page = 1;
    if (page > totalPages) page = totalPages;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (num) => {
    setItemsPerPage(num);
    setCurrentPage(1);
  };

 
  return (
    <>
      <BackButton />
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <div
            className={`table-responsive table-fixed-header overflow-auto  ${
              itemsPerPage >= 20 ? "mb-80" : itemsPerPage > 11 ? "mb-3" : ""
            }`}
          >
            <table
              className={`table table-bordered table-hover  ${
                itemsPerPage >= 20 ? "mb-3" : itemsPerPage < 11 ? "mb-0" : ""
              }`}
            >
              <thead className="table-light">
                <tr>
                  <th>User ID</th>
                  <th>Document Type</th>
                  <th>Upload Date</th>
                  <th style={{ width: "150px" }} className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {documents.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No documents found
                    </td>
                  </tr>
                ) : (
                  documents.map((doc) => (
                    <tr key={doc.id}>
                      <td>{doc.user_id}</td>
                      <td>{doc.document_type}</td>
                      <td>{new Date(doc.uploaded_at).toLocaleDateString()}</td>
                      <td>
                        <div className="d-flex gap-2 justify-content-center imgintbl">
                          <a
                            href={doc.file_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="View"
                          >
                            <VisibilityIcon style={{ fontSize: 20 }} />
                          </a>
                          <span
                            onClick={() => handleDownload(doc.id, doc.document_type)}
                            title="Download"
                            style={{ cursor: 'pointer' }}
                          >
                            <DownloadIcon style={{ fontSize: 20 }} />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
};

export default UserDocuments;

